import { render } from "./ButtonAdd.vue?vue&type=template&id=4a4c6d97&scoped=true"
import script from "./ButtonAdd.vue?vue&type=script&lang=js"
export * from "./ButtonAdd.vue?vue&type=script&lang=js"

import "./ButtonAdd.vue?vue&type=style&index=0&id=4a4c6d97&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a4c6d97"

export default script